export const StarIcon = ({
	strokeColor = "#4BA540",
	fillColor = "none",
	width = 24,
	height = 24,
}: {
	fillColor?: string;
	strokeColor: string;
	width?: number;
	height?: number;
}) => {
	return (
		<svg width={width} height={height} viewBox="0 0 32 33" fill={fillColor}>
			<g id="star-01">
				<path
					id="Icon"
					d="M15.0434 5.1041C15.3507 4.48151 15.5043 4.17022 15.7129 4.07076C15.8944 3.98423 16.1053 3.98423 16.2868 4.07076C16.4954 4.17022 16.649 4.48151 16.9563 5.1041L19.8719 11.0107C19.9626 11.1945 20.008 11.2864 20.0743 11.3578C20.133 11.421 20.2034 11.4721 20.2816 11.5085C20.3699 11.5496 20.4713 11.5644 20.6741 11.594L27.1958 12.5473C27.8826 12.6477 28.226 12.6979 28.3849 12.8656C28.5231 13.0115 28.5882 13.2121 28.5618 13.4114C28.5316 13.6404 28.283 13.8826 27.7858 14.3668L23.0684 18.9616C22.9214 19.1048 22.8479 19.1764 22.8004 19.2616C22.7584 19.3371 22.7315 19.42 22.7211 19.5057C22.7093 19.6025 22.7267 19.7037 22.7614 19.906L23.8745 26.3958C23.9918 27.0803 24.0505 27.4226 23.9402 27.6257C23.8443 27.8024 23.6736 27.9263 23.4759 27.963C23.2487 28.0051 22.9413 27.8435 22.3267 27.5202L16.4963 24.4541C16.3147 24.3586 16.2239 24.3108 16.1282 24.2921C16.0434 24.2754 15.9563 24.2754 15.8716 24.2921C15.7759 24.3108 15.685 24.3586 15.5034 24.4541L9.67307 27.5202C9.05839 27.8435 8.75105 28.0051 8.5238 27.963C8.32608 27.9263 8.15547 27.8024 8.05949 27.6257C7.94917 27.4226 8.00787 27.0803 8.12527 26.3958L9.23835 19.906C9.27305 19.7037 9.2904 19.6025 9.27866 19.5057C9.26827 19.42 9.24132 19.3371 9.19931 19.2616C9.15187 19.1764 9.07834 19.1048 8.93128 18.9616L4.21392 14.3668C3.71672 13.8826 3.46812 13.6404 3.43787 13.4114C3.41155 13.2121 3.47658 13.0115 3.61484 12.8656C3.77375 12.6979 4.11713 12.6477 4.8039 12.5473L11.3256 11.594C11.5284 11.5644 11.6298 11.5496 11.7181 11.5085C11.7963 11.4721 11.8667 11.421 11.9254 11.3578C11.9917 11.2864 12.0371 11.1945 12.1278 11.0107L15.0434 5.1041Z"
					stroke={strokeColor}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
		</svg>
	);
};
